/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ demands: NonNullable<unknown>, created: NonNullable<unknown>, updated: NonNullable<unknown>, tasks: NonNullable<unknown>, failed: NonNullable<unknown> }} Demands_Bulk_Match_RanInputs */

const cs_demands_bulk_match_ran = /** @type {(inputs: Demands_Bulk_Match_RanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Párování dokončeno pro ${i?.demands} poptávek — ${i?.created} vytvořeno, ${i?.updated} aktualizováno, ${i?.tasks} úkolů (${i?.failed} selhalo)`)
};

const en_demands_bulk_match_ran = /** @type {(inputs: Demands_Bulk_Match_RanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Matching finished for ${i?.demands} demands — ${i?.created} created, ${i?.updated} updated, ${i?.tasks} tasks (${i?.failed} failed)`)
};

/**
* | output |
* | --- |
* | "Matching finished for {demands} demands — {created} created, {updated} updated, {tasks} tasks ({failed} failed)" |
*
* @param {Demands_Bulk_Match_RanInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_bulk_match_ran = /** @type {((inputs: Demands_Bulk_Match_RanInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Bulk_Match_RanInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_bulk_match_ran(inputs)
	return cs_demands_bulk_match_ran(inputs)
});